import { getInstance } from './index'
import vstore from '../../store'


export const authGuard = (to, from, next) => {


    const requiresAuth = to.matched.some(record => record.meta.authRequired)
    let requiredRouteRole = [];

    to.matched.some(rec => {
        if (rec.meta.authorizedRole) {
            if (rec.meta.authorizedRole.length > 0) {
                requiredRouteRole = rec.meta.authorizedRole
            }
        }
    })

    if (requiresAuth) {

        const authService = getInstance();

        const fn = async() => {

            // If the user is authenticated, continue with the route
            if (authService.isAuthenticated) {

                /* eslint-disable */
                try {
                    fbq('init', '648192348968608');
                    fbq('track', 'Lead');
                } catch (error) {
                    console.log('Facebook not loaded');
                }
                /* eslint-enable */
                const userData = authService.user
                const userRole = userData['https://admin-api-dot-kiwicheckout.appspot.com/roles'];
                const userV2 = userData['https://admin-api-dot-kiwicheckout.appspot.com/user_v2'];


                if (userRole.length == 0) {

                    if (to.path === '/completing' || to.path === '/system/logout') {
                        return next();
                    } else {
                        return next('/completing')
                    }

                } else {

                    if (vstore.state.user.completed_signup) {
                        if (to.path === '/completing') {
                            return next('/')
                        }
                    }

                    const userCanAccess = requiredRouteRole.some(r => userRole.includes(r));
                    if (userCanAccess) {
                        if (to.path === '/orders' && userV2) {
                            return next('/v2/orders');
                        }
                        return next();
                    } else if (userRole.includes('support')) {
                        return next('/orders');
                    } else {
                        authService.loginWithRedirect({ appState: { targetUrl: to.fullPath } });
                    }

                }


            } else {
                authService.loginWithRedirect({ appState: { targetUrl: to.fullPath } })
            }

        }

        // If loading has already finished, check our auth state using `fn()`
        if (!authService.loading) {
            return fn()
        }

        // Watch for the loading property to change before we check isAuthenticated
        authService.$watch('loading', loading => {
            if (loading === false) {
                return fn()
            }
        });

    } else {
        console.log('calling next');
        next()
    }
}